import {BREAKPOINTS} from "@utils/breakpoints";

export class Mobile {

  init() {
    if(document.querySelector('.pda.pda-v3')) {
      const mobileRearrange = () => {
        const pdaMobileCtaBox = document.querySelector('.pda-mobile-cta-box');
        const pdaCtaBox = document.querySelector('.pda-cta-box');

        if (pdaMobileCtaBox && pdaCtaBox) {
          const isMobileView = window.innerWidth <= BREAKPOINTS.maxTablet;
          const pdaMobileEmpty = pdaMobileCtaBox.innerHTML === '';
          const pdaMobileNotEmpty = pdaMobileCtaBox.innerHTML !== '';

          if (isMobileView && pdaMobileEmpty) {
            while (pdaCtaBox.firstChild) {
              pdaMobileCtaBox.appendChild(pdaCtaBox.firstChild);
            }

          } else if (!isMobileView && pdaMobileNotEmpty) {
            while (pdaMobileCtaBox.firstChild) {
              pdaCtaBox.appendChild(pdaMobileCtaBox.firstChild);
            }
          }
        }
      };

      mobileRearrange();

      window.addEventListener('resize', () => {
        mobileRearrange();
      });
    }
  }
}